import React, { useEffect, useState } from "react";
import { Badge, Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { ClinicalFormFillupRequest, CreateSBARRequest } from "../../../api/ClinicalIntake";
import Fontstyling, {
    clientListDrpDwnStyles,
} from "../../../components/common/comman";
import toastFile from "../../../Service/ToastFile";
import { Formik } from "formik";
import * as Yup from "yup";
import Required from "../../../components/Required";
import { useRef } from "react";
import { getClientsDatabyPaginationbySearch } from "../../../api/User/commonApi";
import { AsyncPaginate } from "react-select-async-paginate";
import { GetCGTMemberID,GetClientByCGTMemberID } from "../../../api/ClinicalIntake/ClinicalIntakeApi";

const schema = Yup.object().shape({
    cgT_Member_ID: Yup.object().required("Please select Plan Insights Member ID"),
    client: Yup.object().nullable("Please select Client Name").required("Please select Client Name"),
    description: Yup.string().required("Please enter description here"),

});
const SBARFormIntakeRequest = () => {
    const user = useSelector((state) => state.userDetails.value);
    const [data,setData] = useState([])
    const [selectedClient, setSelectedClient] = useState();

    const loadIdOptions1 = async (searchQuery, loadedOptions, { page }) => {
        if (searchQuery.length > 3 || searchQuery?.length === 0) {
            try {
                let response = await GetCGTMemberID(100, page, searchQuery);
                const data = await response.data;
                // setCgtIdData([data]);
                const newOptions = data.map((port) => ({
                    value: port.PATIENT_ID,
                    label: port.PATIENT_ID,
                  }));
                return {
                    options: newOptions,
                    hasMore: newOptions.length >= 1,
                    additional: {
                        page: page + 1,
                    },
                };
            } catch (error) {
                console.error("Error fetching data:", error);
                return {
                    options: [],
                    hasMore: false,
                    additional: {
                        page: page,
                    },
                };
            }
        } else {
            return {
                options: [{ value: 0, label: "Please type at least 4 characters" }],
                hasMore: false,
                additional: {
                    page: page,
                },
            };
        }
    };
    const loadOptions = async (searchQuery, loadedOptions, { page }) => {
        if (searchQuery.length > 3 || searchQuery?.length === 0) {
            try {
                let response = await getClientsDatabyPaginationbySearch(
                    user?.UD_id,
                    page,
                    searchQuery
                );
                const data = await response.data.clientsDataModelUDid;
                // setClientData([...clientData, ...data]);
                const newOptions = data.map((port) => ({
                    value: port.clientID,
                    label: port.clientName,
                }));
                return {
                    options: newOptions,
                    hasMore: newOptions.length >= 1,
                    additional: {
                        page: page + 1,
                    },
                };
            } catch (error) {
                console.error("Error fetching data:", error);
                return {
                    options: [],
                    hasMore: false,
                    additional: {
                        page: page,
                    },
                };
            }
        } else {
            return {
                options: [{ value: 0, label: "Please type at least 4 characters" }],
                hasMore: false,
                additional: {
                    page: page,
                },
            };
        }
    };
    const handleActions = (values, { resetForm }) => {
        let payload = {
            userid: user?.UD_id,
            clientId: values.client.value,
            cgT_Member_ID: values.cgT_Member_ID.value,
            userComment: values.description
        };
        CreateSBARRequest(payload).then((res) => {
            if (res?.status === 200 || res?.status === 204) {
                toastFile(res.data, "success");
                setData(res.data);
                setSelectedClient(null)
                resetForm();
            }
            else {
                toastFile(res?.response?.data, "error");
            }
        });
    };
    return (
      <div>
        <div className="d-flex align-item-center justify-content-between py-3 ">
          <div style={Fontstyling.heading}>
            Add details to fill SBAR intake form
          </div>
        </div>
        <Formik
          validationSchema={schema}
          onSubmit={handleActions}
          initialValues={{
            id: "",
            cgT_Member_ID: "",
            client: "",
            description: "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            setFieldValue,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Row className="mb-2 gap-3">
                <Col>
                  <Form.Group>
                    <Form.Label style={Fontstyling.label}>
                      Plan Insights Member ID <Required />
                    </Form.Label>
                    <AsyncPaginate
                      id="5465f"
                      value={values.cgT_Member_ID}
                      loadOptions={loadIdOptions1}
                      debounceTimeout={2500}
                      name="cgT_Member_ID"
                      styles={{
                        ...clientListDrpDwnStyles,
                        control: (base) => ({
                          ...clientListDrpDwnStyles.control(base),
                          border: `1px solid ${
                            errors.cgT_Member_ID &&
                            touched.cgT_Member_ID &&
                            !values.cgT_Member_ID
                              ? "red"
                              : "lightgrey"
                          }`,
                        }),
                      }}
                      placeholder="Select Plan Insights Member ID"
                      onChange={async(option) => {
                        setFieldValue("cgT_Member_ID", option);

                        let res = await GetClientByCGTMemberID(option.label);
                        if (res) {
                          setSelectedClient(res.data[0]);
                          if(res.data.length){
                            setFieldValue("client", {label:res.data[0]?.CLIENTNAME,value:res.data[0]?.CLIENTID});
                          }else{
                            setFieldValue("client", null);
                          }
                        }
                      }}
                      additional={{
                        page: 1,
                      }}
                      isSearchable={true}
                      isOptionDisabled={(e) => e.value === 0}
                    />
                    {errors.cgT_Member_ID &&
                      touched.cgT_Member_ID &&
                      !values.cgT_Member_ID && (
                        <Form.Label style={Fontstyling.errorlabel}>
                          {errors.cgT_Member_ID}
                        </Form.Label>
                      )}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                {selectedClient ?  
                  <Form.Group className="text-start">
                    <Form.Label
                      className="text-nowrap"
                      style={Fontstyling.label}
                    >
                      Client Name
                      <Required />
                    </Form.Label>
                    <Form.Control
                      name="client"
                      type="text"
                      className="py-1 rounded-0"
                      style={Fontstyling.label}
                      value={values.client.label}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled
                      placeholder="Client Name"
                      isInvalid={touched.client && errors.client}
                    />
                   
                  </Form.Group>
                  :
                  <Form.Group className="text-start">
                  <Form.Label
                    className="text-nowrap"
                    style={Fontstyling.label}
                  >
                    Client Name
                    <Required />
                  </Form.Label>
                 
                  <AsyncPaginate
                                      name="client"
                                      value={values.client}
                                      loadOptions={loadOptions}
                                      debounceTimeout={2500}
                                      onBlur={handleBlur}
                                      styles={{
                                          ...clientListDrpDwnStyles,
                                          control: (base) => ({
                                              ...clientListDrpDwnStyles.control(base),
                                              border: `1px solid ${errors.client && touched.client
                                                  ? "red"
                                                  : "lightgrey"
                                                  }`,
                                          }),
                                      }}
                                      placeholder="Select Client Name"
                                      onChange={(option) => {
                                          setFieldValue("client", option);
                                      }}
                                      isSearchable={true}
                                      additional={{
                                          page: 1,
                                      }}
                                      menuPlacement="auto"
                                  />
                  {errors.client && touched.client && (
                    <Form.Label style={Fontstyling.errorlabel}>
                      {errors.client}
                    </Form.Label>
                  )}
                </Form.Group>
                }
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group className="text-start mt-2">
                    <Form.Label
                      className="text-nowrap"
                      style={Fontstyling.label}
                    >
                      Description of Request
                      <Required />
                    </Form.Label>
                    <Form.Control
                      name="description"
                      as="textarea"
                      type="text"
                      placeholder="Leave a description here"
                      style={{
                        ...Fontstyling.label,
                        minHeight: "300px",
                        border: `1px solid ${
                          errors.description && touched.description
                            ? "red"
                            : "lightgrey"
                        }`,
                      }}
                      value={values.description}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  {errors.description && touched.description && (
                    <Form.Label style={Fontstyling.errorlabel}>
                      {errors.description}
                    </Form.Label>
                  )}
                </Col>
              </Row>
              <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                <button style={Fontstyling.savebutton} type="submit">
                  Submit
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
};

export default SBARFormIntakeRequest;
